import { SectionLoader } from '@/shared/components/section-loader';

export const HoursCalculationLoading = () => {
  return <SectionLoader />;
};
